/**
 * @generated SignedSource<<dd2d7e9c6feb9aea53b22d881e88926e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FileStatus = "ERROR" | "PENDING" | "PROCESSING" | "READY" | "WAIT_FOR_PROCESSING";
import { FragmentRefs } from "relay-runtime";
export type WidgetFile_widgetFile$data = {
  readonly files: ReadonlyArray<{
    readonly file: {
      readonly id: string;
      readonly status: FileStatus;
    };
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFileDynamic_widgetFile" | "WidgetFileStatic_widgetFile">;
  readonly " $fragmentType": "WidgetFile_widgetFile";
};
export type WidgetFile_widgetFile$key = {
  readonly " $data"?: WidgetFile_widgetFile$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFile_widgetFile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetFile_widgetFile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetFileEdge",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "file",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetFileStatic_widgetFile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetFileDynamic_widgetFile"
    }
  ],
  "type": "WidgetFile",
  "abstractKey": null
};

(node as any).hash = "f1dd5b9332e1f24992b5686bf553af1d";

export default node;
